import Button from 'components/button';
import style from '../aboutObject/styles.module.scss';
import { useState } from 'react';
import ModalAnalogsEstimate from '../modals/modalAnalogs/modalAnalogsEstimate';
import {
  IPrimaryFacilityRecommendationsResponse,
  ISecondaryFacilityRecommendationsResponse,
} from 'screens/estimate/interfaces';

interface IAboutObjectEstimateButton {
  isSecondary: boolean;
  sameFacilityCount: number;
  recommendations:
    | ISecondaryFacilityRecommendationsResponse
    | IPrimaryFacilityRecommendationsResponse;
}

export const AboutObjectEstimateButtonRecommendations = ({
  isSecondary,
  sameFacilityCount,
  recommendations,
}: IAboutObjectEstimateButton) => {
  const [isOpenModalAnalog, setIsOpenModalAnalog] = useState(false);

  const handleToggleModal = () => {
    setIsOpenModalAnalog((prev) => !prev);
  };

  return (
    <div className={style.aboutObject__countAnalog}>
      <div>
        <span style={{ fontSize: 14 }}>
          <i>{`Всего схожих квартир ${isSecondary ? 'рядом' : ''} в продаже:`}</i>
        </span>
        <span style={{ fontSize: 16 }}>{` ${sameFacilityCount}`}</span>
        <div className={style.aboutObject__button}>
          <Button variant={'dark'} label='Показать схожие квартиры' onClick={handleToggleModal} />
        </div>
      </div>
      <ModalAnalogsEstimate
        isSecondary={isSecondary}
        isOpen={isOpenModalAnalog}
        onDismiss={handleToggleModal}
        listAnalogs={recommendations}
        countAnalog={sameFacilityCount}
      />
    </div>
  );
};
